<template>
  <div id="chart">
    <VueApexCharts type="scatter" ref="chart" width="100%" :height="smallChart === true ? '200%' : '300%'" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

import { DrawCircle, DrawLine, DrawPolyQPd, getYFromLinearInterpolationBetweenPoints } from "../../ppds/drawChart.js";

export default {
  name: "ApexScatterChartMixed",
  components: {
    VueApexCharts,
  },
  props: {
    chart: {
      type: String,
      require: true,
    },
    Smax: {
      type: Number,
      require: true,
    },
    Pmax: {
      type: Number,
      require: true,
    },
    Qmax: {
      type: Number,
      require: true,
    },
    QPmax: {
      type: Number,
      require: true,
    },
    powerFactor: {
      type: Number,
      require: true,
    },
    P1: {
      type: Number,
      require: false,
    },
    P2: {
      type: Number,
      require: false,
    },
    P3: {
      type: Number,
      require: false,
    },
    Q1: {
      type: Number,
      require: false,
    },
    Q2: {
      type: Number,
      require: false,
    },
    Q3: {
      type: Number,
      require: false,
    },
    S1: {
      type: Number,
      require: false,
    },
    S2: {
      type: Number,
      require: false,
    },
    S3: {
      type: Number,
      require: false,
    },
    U1: {
      type: Number,
      require: false,
    },
    U2: {
      type: Number,
      require: false,
    },
    U3: {
      type: Number,
      require: false,
    },
    P1fU1: {
      type: Number,
      require: false,
    },
    P2fU2: {
      type: Number,
      require: false,
    },
    P3fU3: {
      type: Number,
      require: false,
    },
    Q1fU1: {
      type: Number,
      require: false,
    },
    Q2fU2: {
      type: Number,
      require: false,
    },
    Q3fU3: {
      type: Number,
      require: false,
    },
    directionP1: {
      type: Number,
      require: false,
    },
    directionP2: {
      type: Number,
      require: false,
    },
    directionP3: {
      type: Number,
      require: false,
    },
    frequency: {
      type: Number,
      require: false,
    },
    /*     frequencyMin: {
      type: Number,
      require: false,
    },
    frequencyMax: {
      type: Number,
      require: false,
    }, */
    v1: {
      type: Number,
      require: false,
    },
    v2: {
      type: Number,
      require: false,
    },
    v3: {
      type: Number,
      require: false,
    },
    v4: {
      type: Number,
      require: false,
    },
    y1: {
      type: Number,
      require: false,
    },
    y2: {
      type: Number,
      require: false,
    },
    y3: {
      type: Number,
      require: false,
    },
    y4: {
      type: Number,
      require: false,
    },

    v5: {
      type: Number,
      require: false,
    },
    v6: {
      type: Number,
      require: false,
    },
    v7: {
      type: Number,
      require: false,
    },
    activeMinimumPowerPU: {
      type: Number,
      require: false,
    },
    pfUPowerLimit: {
      type: Number,
      require: false,
    },
    PFCurveForCosPhi_PowerReponse_X1: {
      type: Number,
      require: false,
    },
    PFCurveForCosPhi_PowerReponse_X2: {
      type: Number,
      require: false,
    },
    qfULockOut: {
      type: Number,
      require: false,
    },
    qfULockIn: {
      type: Number,
      require: false,
    },
    P_HF_ThresholdFreq: {
      type: Number,
      require: false,
    },
    P_HF_StopFreq: {
      type: Number,
      require: false,
    },
    P_HF_Gradient: {
      type: Number,
      require: false,
    },
    P_HF_Delay: {
      type: Number,
      require: false,
    },
    P_HF_StopFreq2: {
      type: Number,
      require: false,
    },
    P_HF_DeactivationTime: {
      type: Number,
      require: false,
    },
    P_HF_P1Limit: {
      type: Number,
      require: false,
    },
    P_HF_P2Limit: {
      type: Number,
      require: false,
    },
    P_HF_P3Limit: {
      type: Number,
      require: false,
    },
    P_HF_P1Frozen: {
      type: Number,
      require: false,
    },
    P_HF_P2Frozen: {
      type: Number,
      require: false,
    },
    P_HF_P3Frozen: {
      type: Number,
      require: false,
    },
    P_HF_P1Reference: {
      type: Number,
      require: false,
    },
    P_HF_P2Reference: {
      type: Number,
      require: false,
    },
    P_HF_P3Reference: {
      type: Number,
      require: false,
    },
    EN_P_f_f_Gradient: {
      type: Boolean,
      require: false,
    },
    P_LF_ThresholdFreq: {
      type: Number,
      require: false,
    },
    P_LF_StopFreq: {
      type: Number,
      require: false,
    },
    P_LF_Gradient: {
      type: Number,
      require: false,
    },
    P_LF_Delay: {
      type: Number,
      require: false,
    },
    P_LF_CurrentLimit: {
      type: Number,
      require: false,
    },
    P_LF_P1: {
      type: Number,
      require: false,
    },
    P_LF_P2: {
      type: Number,
      require: false,
    },
    P_LF_P3: {
      type: Number,
      require: false,
    },
    dark: {
      type: Boolean,
      default: false,
      require: false,
    },
    smallChart: {
      type: Boolean,
      default: false,
      require: false,
    },
  },

  data: () => ({
    timer: null,

    frequencyMax: 52.5,
    frequencyMin: 47.5,

    shadeTo: "light",
    mode: "light",

    color: {
      p1: {
        line: "#E91E63",
        point: "#D50000",
      },
      p2: {
        line: "#9C27B0",
        point: "#4A148C",
      },
      p3: {
        line: "#009688",
        point: "#00BCD4",
      },
      drawA: "#03A9F4",
      drawB: "#795548",
      drawC: "#9C27B0",
      drawD: "#03A9F4",
    },

    staticArrayChartSeries1: [],
    staticArrayChartSeries2: [],
    staticArrayChartSeries3: [],
    staticArrayChartSeries4: [],
    staticArrayChartSeries5: [],
    staticArrayChartSeries6: [],
    staticArrayChartSeries7: [],
    staticArrayChartSeries8: [],
    staticArrayChartSeries9: [],
    staticArrayChartSeries10: [],

    stepPowerFactors: 0.01,
    step: 0.05,
    stepCircle: 2,
    stepWatts: 100,

    roundPoints: 10,

    markerSizeAxis: 2,
    markerSizeArea: 3,
    markerSizeSmallPoints: 4,
    markerSizePoints: 10,

    series: [],
    chartOptions: {},
  }),
  created() {
    this.initChart();

    this.drawStaticPoints();
    this.updateChart();
  },
  computed: {},
  mounted() {},
  methods: {
    extremeLimitationXYDataSeries(array, min, max) {
      for (let index = 0; index < array.length; index++) {
        if (array[index][1] > max) {
          array[index][1] = max;
        }
        if (array[index][1] < min) {
          array[index][1] = min;
        }
      }
      return array;
    },
    initChart() {
      this.chartOptions = {
        grid: {
          show: true,
          borderColor: this.dark ? "#424242" : "#9E9E9E",
          strokeDashArray: 0,
          position: "back",
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
          padding: {
            top: 12,
            right: 12,
            bottom: 12,
            left: 12,
          },
        },
        chart: {
          type: "scatter",
          background: this.dark ? "#1E1E1E" : "#FFFFFF",
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          zoom: {
            enabled: false,
            type: "xy",
          },
          toolbar: {
            show: false,
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        xaxis: {
          tickAmount: 16,
          labels: {
            style: {
              colors: this.dark ? "#E0E0E0" : "#212121",
            },
            formatter: function (val) {
              return parseFloat(val).toFixed(0); // + "VAr";
            },
          },

          title: {
            text: "Jalový výkon [VAr]",
            offsetX: 0,
            offsetY: 0,
            style: {
              color: this.dark ? "#E0E0E0" : "#212121",
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              cssClass: "apexcharts-xaxis-title",
            },
          },
        },
        yaxis: {
          tickAmount: 8,

          labels: {
            style: {
              colors: this.dark ? "#E0E0E0" : "#212121",
            },
            formatter: function (val) {
              return parseFloat(val).toFixed(0); // + "VAr";
            },
          },
          title: {
            text: "Činný výkon [W]",
            offsetX: 0,
            offsetY: 0,
            style: {
              color: this.dark ? "#E0E0E0" : "#212121", // Barva titulku osy
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              cssClass: "apexcharts-xaxis-title",
            },
          },
        },

        tooltip: { enabled: false },

        title: {
          text: "",
          align: "middle",
          margin: 0,
          offsetX: 0,
          offsetY: 20,
          floating: false,
          style: {
            fontSize: "14px",
            fontWeight: "bold",
            fontFamily: undefined,
          },
        },

        markers: {
          size: [2.5, 2.5, 3, 9],
          colors: this.dark ? "#FFEB3B" : undefined, // Barva bodů v dark režimu
          strokeColors: this.dark ? "#212121" : "#fff", // Rámeček bodů
          strokeWidth: 2,
          strokeOpacity: 0.9,
          strokeDashArray: 0,
          fillOpacity: 1,
          discrete: [],
          shape: "circle",
          radius: 2,
          offsetX: 0,
          offsetY: 0,
          onClick: undefined,
          onDblClick: undefined,
          showNullDataPoints: true,
          hover: {
            size: undefined,
            sizeOffset: 3,
          },
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          labels: {
            colors: this.dark ? "#E0E0E0" : "#212121",
          },
          markers: {
            fillColors: this.dark ? ["#FFEB3B", "#F9C80E"] : undefined,
          },
        },
      };
    },
    updateChart() {
      let U1 = this.U1;
      let U2 = this.U2;
      let U3 = this.U3;
      let P1 = this.P1;
      let P2 = this.P2;
      let P3 = this.P3;
      let Q1 = this.Q1;
      let Q2 = this.Q2;
      let Q3 = this.Q3;
      let S1 = this.S1;
      let S2 = this.S2;
      let S3 = this.S3;

      let Qmax = this.Qmax;
      let Smax = this.Smax;
      let QPmax = this.QPmax;

      let P1fU1 = this.P1fU1;
      let P2fU2 = this.P2fU2;
      let P3fU3 = this.P3fU3;

      let Q1fU1 = this.Q1fU1;
      let Q2fU2 = this.Q2fU2;
      let Q3fU3 = this.Q3fU3;

      this.series = [];

      let dynamicPointA = [];
      let dynamicPointB = [];
      let dynamicPointC = [];

      let dynamicPointX = [];
      let dynamicPointY = [];
      let dynamicPointZ = [];

      if (this.chart === "A") {
        dynamicPointA.push([Q1, P1]);
        dynamicPointB.push([Q2, P2]);
        dynamicPointC.push([Q3, P3]);

        /* this.changeChartName("Požadavky na dodávku / odběr jalového výkonu při Un"); */
        this.changeXYAxis("Jalový výkon [VAr]", "Činný výkon [W]", 0, 0, -Smax - 300, Smax + 300, 0, Smax + 300);
        this.changeMarkersSize([this.markerSizeArea, this.markerSizeArea, this.markerSizeArea, this.markerSizePoints, this.markerSizePoints, this.markerSizePoints]);

        this.series = [
          {
            name: "Maximální zdánlivý výkon v jednom přípojném bodě",
            type: "scatter",
            data: this.staticArrayChartSeries1,
            color: this.color.drawA,
          },
          {
            name: "Nepovinné požadavky dodávky / odběru jalového výkonu",
            type: "scatter",
            data: this.staticArrayChartSeries2,
            color: this.color.drawB,
          },
          {
            name: "Oblast povinné podpory sítě",
            type: "scatter",
            data: this.staticArrayChartSeries3,
            color: this.color.drawC,
          },
          {
            name: "Aktuální výkon střídače P1",
            type: "scatter",
            data: dynamicPointA,
            color: this.color.p1.point,
          },
          {
            name: "Aktuální výkon střídače P2",
            type: "scatter",
            data: dynamicPointB,
            color: this.color.p2.point,
          },
          {
            name: "Aktuální výkon střídače P3",
            type: "scatter",
            data: dynamicPointC,
            color: this.color.p3.point,
          },
        ];
      } else if (this.chart === "B") {
        dynamicPointA.push([Q1 === 0 && P1 === 0 ? 0 : Q1 / P1, U1 / 230.0]);
        dynamicPointB.push([Q2 === 0 && P2 === 0 ? 0 : Q2 / P2, U2 / 230.0]);
        dynamicPointC.push([Q3 === 0 && P3 === 0 ? 0 : Q3 / P3, U3 / 230.0]);

        /* this.changeChartName("Požadavky pro napětí odlišná od jmenovitého (jalový výkon výrobního modulu pro P=Pd)"); */
        this.changeXYAxis("Q / Pd", "U / Un", 3, 3, -QPmax - 0.1, QPmax + 0.1, 0.8, 1.15);
        this.changeMarkersSize([this.markerSizeArea, this.markerSizePoints, this.markerSizePoints, this.markerSizePoints]);

        this.series = [
          {
            name: "Oblast pro minimální požadavky pro VM",
            type: "scatter",
            data: this.staticArrayChartSeries1,
            color: this.color.drawA,
          },
          {
            name: "Aktuální výkon střídače P1",
            type: "scatter",
            data: dynamicPointA,
            color: this.color.p1.point,
          },
          {
            name: "Aktuální výkon střídače P2",
            type: "scatter",
            data: dynamicPointB,
            color: this.color.p2.point,
          },
          {
            name: "Aktuální výkon střídače P3",
            type: "scatter",
            data: dynamicPointC,
            color: this.color.p3.point,
          },
        ];
      } else if (this.chart === "C") {
        if (U1 < this.v5 - 5) {
          U1 = this.v5 - 5;
        }
        if (U2 < this.v5 - 5) {
          U2 = this.v5 - 5;
        }
        if (U3 < this.v5 - 5) {
          U3 = this.v5 - 5;
        }

        dynamicPointA.push([U1, P1fU1 / (Smax / 100)]);
        dynamicPointB.push([U2, P2fU2 / (Smax / 100)]);
        dynamicPointC.push([U3, P3fU3 / (Smax / 100)]);

        dynamicPointX.push([U1, P1 / (Smax / 100)]);
        dynamicPointY.push([U2, P2 / (Smax / 100)]);
        dynamicPointZ.push([U3, P3 / (Smax / 100)]);

        /* this.changeChartName("P(U) - Snížení činného výkonu závislé na napětí"); */
        this.changeXYAxis("Napětí U [V]", "Maximální výkon P / Pn [%]", 0, 2, this.v5 - 5, this.v7, 0, 114.29);
        this.changeMarkersSize([this.markerSizeArea, this.markerSizeSmallPoints, this.markerSizePoints, this.markerSizePoints, this.markerSizePoints, this.markerSizePoints, this.markerSizePoints, this.markerSizePoints]);

        this.series = [
          {
            name: "Maximální dovolený generovaný výkon",
            type: "scatter",
            data: this.staticArrayChartSeries1,
            color: this.color.drawA,
          },
          {
            name: "U5, U6, U7",
            type: "scatter",
            data: this.staticArrayChartSeries2,
            color: this.color.drawB,
          },
          {
            name: "Omezení pro aktuální napětí U1",
            type: "scatter",
            data: dynamicPointA,
            color: this.color.p1.point,
          },
          {
            name: "Omezení pro aktuální napětí U2",
            type: "scatter",
            data: dynamicPointB,
            color: this.color.p2.point,
          },
          {
            name: "Omezení pro aktuální napětí U3",
            type: "scatter",
            data: dynamicPointC,
            color: this.color.p3.point,
          },
          {
            name: "Aktuální výkon střídače Q1",
            type: "scatter",
            data: dynamicPointX,
            color: this.color.p1.point,
          },
          {
            name: "Aktuální výkon střídače Q2",
            type: "scatter",
            data: dynamicPointY,
            color: this.color.p2.point,
          },
          {
            name: "Aktuální výkon střídače Q3",
            type: "scatter",
            data: dynamicPointZ,
            color: this.color.p3.point,
          },
        ];
      } else if (this.chart === "D") {
        dynamicPointA.push([U1, getYFromLinearInterpolationBetweenPoints(this.v1, this.y1, this.v2, this.y2, this.v3, this.y3, this.v4, this.y4, U1)]);
        dynamicPointB.push([U2, getYFromLinearInterpolationBetweenPoints(this.v1, this.y1, this.v2, this.y2, this.v3, this.y3, this.v4, this.y4, U2)]);
        dynamicPointC.push([U3, getYFromLinearInterpolationBetweenPoints(this.v1, this.y1, this.v2, this.y2, this.v3, this.y3, this.v4, this.y4, U3)]);

        if (this.directionP1 === 1) {
          dynamicPointX.push([U1, (Q1fU1 / Qmax) * 100]);
        } else {
          dynamicPointX.push([U1, -(Q1fU1 / Qmax) * 100]);
        }

        if (this.directionP2 === 1) {
          dynamicPointY.push([U2, (Q2fU2 / Qmax) * 100]);
        } else {
          dynamicPointY.push([U2, -(Q2fU2 / Qmax) * 100]);
        }

        if (this.directionP3 === 1) {
          dynamicPointZ.push([U3, (Q3fU3 / Qmax) * 100]);
        } else {
          dynamicPointZ.push([U3, -(Q3fU3 / Qmax) * 100]);
        }

        /* this.changeChartName("Q(U) - Jalový výkon závislý na napětí"); */
        this.changeXYAxis("Napětí U [V]", "Jalový výkon Q / Qn [%]", 2, 0, this.v1 - 20, this.v4 + 20, this.y4 - 33, this.y1 + 33);
        this.changeMarkersSize([this.markerSizeArea, this.markerSizeSmallPoints, this.markerSizePoints, this.markerSizePoints, this.markerSizePoints, this.markerSizePoints, this.markerSizePoints, this.markerSizePoints]);

        this.series = [
          {
            name: "Q(U)",
            type: "scatter",
            data: this.staticArrayChartSeries1,
            color: this.color.drawA,
          },
          {
            name: "U1, U2, U3, U4",
            type: "scatter",
            data: this.staticArrayChartSeries2,
            color: this.color.drawB,
          },
          {
            name: "Teoretická hodnota Q1",
            type: "scatter",
            data: dynamicPointA,
            color: this.color.p1.point,
          },
          {
            name: "Teoretická hodnota Q2",
            type: "scatter",
            data: dynamicPointB,
            color: this.color.p2.point,
          },
          {
            name: "Teoretická hodnota Q3",
            type: "scatter",
            data: dynamicPointC,
            color: this.color.p3.point,
          },
          {
            name: "Aktuální jalový výkon Q1",
            type: "scatter",
            data: dynamicPointX,
            color: this.color.p1.point,
          },
          {
            name: "Aktuální jalový výkon Q2",
            type: "scatter",
            data: dynamicPointY,
            color: this.color.p2.point,
          },
          {
            name: "Aktuální jalový výkon Q3",
            type: "scatter",
            data: dynamicPointZ,
            color: this.color.p3.point,
          },
        ];
      } else if (this.chart === "E") {
        dynamicPointA.push([P1, Math.round((P1 / S1) * 1000) / 1000]);
        dynamicPointB.push([P2, Math.round((P2 / S2) * 1000) / 1000]);
        dynamicPointC.push([P3, Math.round((P3 / S3) * 1000) / 1000]);

        /* this.changeChartName("cos phi (P) - Účiník závislý na činném výkonu"); */
        this.changeXYAxis("Činný výkon [W]", "Učiník [-]", 0, 3, 0, Smax + 20, this.powerFactor, 1);
        this.changeMarkersSize([this.markerSizeArea, this.markerSizePoints, this.markerSizePoints, this.markerSizePoints]);

        this.series = [
          {
            name: "cosPhi(P)",
            type: "scatter",
            data: this.staticArrayChartSeries1,
            color: this.color.drawA,
          },
          {
            name: "Aktuální učiník střídače P1",
            type: "scatter",
            data: dynamicPointA,
            color: this.color.p1.point,
          },
          {
            name: "Aktuální učiník střídače P2",
            type: "scatter",
            data: dynamicPointB,
            color: this.color.p2.point,
          },
          {
            name: "Aktuální učiník střídače P3",
            type: "scatter",
            data: dynamicPointC,
            color: this.color.p3.point,
          },
        ];
      } else if (this.chart === "F") {
        let qfULockIn = 0;
        let qfULockOut = 0;

        if (this.qfULockIn > 1.0) {
          qfULockIn = this.qfULockIn / 100;
        } else {
          qfULockIn = this.qfULockIn;
        }

        if (this.qfULockOut > 1.0) {
          qfULockOut = this.qfULockOut / 100;
        } else {
          qfULockOut = this.qfULockOut;
        }

        if (P1 >= qfULockIn * Smax) {
          dynamicPointA.push([P1, 1]);
        } else if (P1 <= qfULockOut * Smax) {
          dynamicPointA.push([P1, 0]);
        }
        if (P2 >= qfULockIn * Smax) {
          dynamicPointB.push([P2, 1]);
        } else if (P2 <= qfULockOut * Smax) {
          dynamicPointB.push([P2, 0]);
        }
        if (P3 >= qfULockIn * Smax) {
          dynamicPointC.push([P3, 1]);
        } else if (P3 <= qfULockOut * Smax) {
          dynamicPointC.push([P3, 0]);
        }

        /* this.changeChartName("Aktivace Q(U) pomocí dvou výkonostních úrovní"); */
        this.changeXYAxis("Činný výkon [W]", "Aktivace Q(U)", 0, 1, 0, Smax + 20, 0, 1);
        this.changeMarkersSize([this.markerSizeArea, this.markerSizeSmallPoints, this.markerSizePoints, this.markerSizePoints, this.markerSizePoints]);

        this.series = [
          {
            name: "Aktivace Q(U)",
            type: "scatter",
            data: this.staticArrayChartSeries1,
            color: this.color.drawA,
          },
          {
            name: "LockIn, LockOut",
            type: "scatter",
            data: this.staticArrayChartSeries2,
            color: this.color.drawB,
          },
          {
            name: "Aktuální výkon střídače P1",
            type: "scatter",
            data: dynamicPointA,
            color: this.color.p1.point,
          },
          {
            name: "Aktuální výkon střídače P2",
            type: "scatter",
            data: dynamicPointB,
            color: this.color.p2.point,
          },
          {
            name: "Aktuální výkon střídače P3",
            type: "scatter",
            data: dynamicPointC,
            color: this.color.p3.point,
          },
        ];
      } else if (this.chart === "G") {
        dynamicPointA.push([this.frequency, this.P_HF_P1Limit]);
        dynamicPointB.push([this.frequency, this.P_HF_P2Limit]);
        dynamicPointC.push([this.frequency, this.P_HF_P3Limit]);

        dynamicPointX.push([this.frequency, P1]);
        dynamicPointY.push([this.frequency, P2]);
        dynamicPointZ.push([this.frequency, P3]);

        this.changeXYAxis("Frekvence [Hz]", "Požadavek Nabíjení / Limit Generování [W]", 2, 0, this.P_LF_ThresholdFreq, this.frequencyMax, -Smax, Smax);
        this.changeMarkersSize([
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizePoints,
          this.markerSizePoints,
          this.markerSizePoints,
          this.markerSizePoints,
          this.markerSizePoints,
          this.markerSizePoints,
          this.markerSizeAxis,
        ]);

        this.series = [
          {
            name: "100% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries1,
            color: "#F44336",
          },
          {
            name: "75% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries2,
            color: "#E91E63",
          },
          {
            name: "50% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries3,
            color: "#9C27B0",
          },
          {
            name: "25% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries4,
            color: "#673AB7",
          },
          {
            name: "0% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries5,
            color: "#3F51B5",
          },
          {
            name: "-25% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries6,
            color: "#2196F3",
          },
          {
            name: "-50% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries7,
            color: "#03A9F4",
          },
          {
            name: "-75% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries8,
            color: "#00BCD4",
          },
          {
            name: "-100% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries9,
            color: "#009688",
          },

          {
            name: "Výkonový limit P1",
            type: "scatter",
            data: dynamicPointA,
            color: this.color.p1.point,
          },
          {
            name: "Výkonový limit P2",
            type: "scatter",
            data: dynamicPointB,
            color: this.color.p2.point,
          },
          {
            name: "Výkonový limit P3",
            type: "scatter",
            data: dynamicPointC,
            color: this.color.p3.point,
          },
          {
            name: "Aktuální výkon střídače P1",
            type: "scatter",
            data: dynamicPointX,
            color: this.color.p1.point,
          },
          {
            name: "Aktuální výkon střídače P2",
            type: "scatter",
            data: dynamicPointY,
            color: this.color.p2.point,
          },
          {
            name: "Aktuální výkon střídače P3",
            type: "scatter",
            data: dynamicPointZ,
            color: this.color.p3.point,
          },
          {
            name: "-",
            type: "scatter",
            data: this.staticArrayChartSeries10,
            color: this.dark == true ? "#FFFFFF" : "#263238",
          },
        ];
      } else if (this.chart === "H") {
        dynamicPointA.push([this.frequency, this.P_LF_P1]);
        dynamicPointB.push([this.frequency, this.P_LF_P2]);
        dynamicPointC.push([this.frequency, this.P_LF_P3]);

        dynamicPointX.push([this.frequency, P1]);
        dynamicPointY.push([this.frequency, P2]);
        dynamicPointZ.push([this.frequency, P3]);

        this.changeXYAxis("Frekvence [Hz]", "Limit Nabíjení / Požadavek Generování [W]", 2, 0, this.frequencyMin, this.P_HF_ThresholdFreq, -Smax, Smax);
        this.changeMarkersSize([
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizeArea,
          this.markerSizePoints,
          this.markerSizePoints,
          this.markerSizePoints,
          this.markerSizePoints,
          this.markerSizePoints,
          this.markerSizePoints,
          this.markerSizeAxis,
        ]);

        this.series = [
          {
            name: "100% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries1,
            color: "#F44336",
          },
          {
            name: "75% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries2,
            color: "#E91E63",
          },
          {
            name: "50% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries3,
            color: "#9C27B0",
          },
          {
            name: "25% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries4,
            color: "#673AB7",
          },
          {
            name: "0% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries5,
            color: "#3F51B5",
          },
          {
            name: "-25% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries6,
            color: "#2196F3",
          },
          {
            name: "-50% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries7,
            color: "#03A9F4",
          },
          {
            name: "-75% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries8,
            color: "#00BCD4",
          },
          {
            name: "-100% Pn",
            type: "scatter",
            data: this.staticArrayChartSeries9,
            color: "#009688",
          },
          {
            name: "Výkonový limit P1",
            type: "scatter",
            data: dynamicPointA,
            color: this.color.p1.point,
          },
          {
            name: "Výkonový limit P2",
            type: "scatter",
            data: dynamicPointB,
            color: this.color.p2.point,
          },
          {
            name: "Výkonový limit P3",
            type: "scatter",
            data: dynamicPointC,
            color: this.color.p3.point,
          },
          {
            name: "Aktuální výkon střídače P1",
            type: "scatter",
            data: dynamicPointX,
            color: this.color.p1.point,
          },
          {
            name: "Aktuální výkon střídače P2",
            type: "scatter",
            data: dynamicPointY,
            color: this.color.p2.point,
          },
          {
            name: "Aktuální výkon střídače P3",
            type: "scatter",
            data: dynamicPointZ,
            color: this.color.p3.point,
          },
          {
            name: "-",
            type: "scatter",
            data: this.staticArrayChartSeries10,
            color: this.dark == true ? "#FFFFFF" : "#263238",
          },
        ];
      }
    },
    setTheme() {
      if (this.dark === true) {
        this.shadeTo = "dark";
        this.mode = "dark";
        this.updateTheme();
      } else {
        this.shadeTo = "light";
        this.mode = "light";
        this.updateTheme();
      }
    },
    updateTheme() {
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          theme: {
            mode: this.mode,
            palette: "palette1",
            monochrome: {
              enabled: false,
              color: "#F9C80E",
              shadeTo: this.shadeTo,
              shadeIntensity: 0.65,
            },
          },
        },
      };

      /* 
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          theme: {
            mode: this.mode,
            palette: "palette8",
            monochrome: {
              enabled: false,
              color: "#F9C80E",
              shadeTo: this.shadeTo,
              shadeIntensity: 0.25,
            },
          },
        },
      }; 
      */

      /*     this.chartOptions = {
        grid: {
          show: true,
          borderColor: this.dark ? "#424242" : "#9E9E9E",
          strokeDashArray: 0,
          position: "back",
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
          padding: {
            top: 12,
            right: 12,
            bottom: 12,
            left: 12,
          },
        },
        chart: {
          type: "scatter",
          background: this.dark ? "#1E1E1E" : "#FFFFFF",
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          zoom: {
            enabled: false,
            type: "xy",
          },
          toolbar: {
            show: false,
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        xaxis: {
          tickAmount: 16,
          labels: {
            style: {
              colors: this.dark ? "#E0E0E0" : "#212121",
            },
            formatter: function (val) {
              return parseFloat(val).toFixed(0); // + "VAr";
            },
          },

          title: {
            text: "Jalový výkon [VAr]",
            offsetX: 0,
            offsetY: 0,
            style: {
              color: this.dark ? "#E0E0E0" : "#212121",
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              cssClass: "apexcharts-xaxis-title",
            },
          },
        },
        yaxis: {
          tickAmount: 8,

          labels: {
            style: {
              colors: this.dark ? "#E0E0E0" : "#212121",
            },
            formatter: function (val) {
              return parseFloat(val).toFixed(0); // + "VAr";
            },
          },
          title: {
            text: "Činný výkon [W]",
            offsetX: 0,
            offsetY: 0,
            style: {
              color: this.dark ? "#E0E0E0" : "#212121", // Barva titulku osy
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              cssClass: "apexcharts-xaxis-title",
            },
          },
        },

        tooltip: { enabled: false },

        title: {
          text: "",
          align: "middle",
          margin: 0,
          offsetX: 0,
          offsetY: 20,
          floating: false,
          style: {
            fontSize: "14px",
            fontWeight: "bold",
            fontFamily: undefined,
          },
        },

        markers: {
          size: [2.5, 2.5, 3, 9],
          colors: this.dark ? "#FFEB3B" : undefined, // Barva bodů v dark režimu
          strokeColors: this.dark ? "#212121" : "#fff", // Rámeček bodů
          strokeWidth: 2,
          strokeOpacity: 0.9,
          strokeDashArray: 0,
          fillOpacity: 1,
          discrete: [],
          shape: "circle",
          radius: 2,
          offsetX: 0,
          offsetY: 0,
          onClick: undefined,
          onDblClick: undefined,
          showNullDataPoints: true,
          hover: {
            size: undefined,
            sizeOffset: 3,
          },
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          labels: {
            colors: this.dark ? "#E0E0E0" : "#212121",
          },
          markers: {
            fillColors: this.dark ? ["#FFEB3B", "#F9C80E"] : undefined,
          },
        },
      }; */
    },
    pushPointsIntoExistingArray(existingArray, points) {
      if (points.length === 0) {
        return;
      }

      for (let index = 0; index < points.length; index++) {
        existingArray.push(points[index]);
      }
    },
    drawStaticPoints() {
      let xy = [];

      this.staticArrayChartSeries1 = [];
      this.staticArrayChartSeries2 = [];
      this.staticArrayChartSeries3 = [];
      this.staticArrayChartSeries4 = [];
      this.staticArrayChartSeries5 = [];
      this.staticArrayChartSeries6 = [];
      this.staticArrayChartSeries7 = [];
      this.staticArrayChartSeries8 = [];
      this.staticArrayChartSeries9 = [];
      this.staticArrayChartSeries10 = [];

      if (this.chart === "A") {
        xy = DrawCircle(1.0 * this.Smax, 0, 180, this.stepCircle, this.roundPoints);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawCircle(0.1 * this.Smax, 0, 180, this.stepCircle * 5, 10);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries2, xy);

        xy = DrawLine(-this.Qmax, this.Pmax, this.Qmax, this.Pmax, this.stepWatts * 0.5, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries3, xy);

        xy = DrawLine(-this.Qmax, this.Pmax, 0, 0, this.stepWatts * 0.25, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries3, xy);

        xy = DrawLine(this.Qmax, this.Pmax, 0, 0, this.stepWatts * 0.25, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries3, xy);
      } else if (this.chart === "B") {
        xy = DrawLine(-this.QPmax, 1.1, 0, 1.1, this.QPmax / 20, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(0, 1.1, this.QPmax, 1.05, this.QPmax / 20, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(this.QPmax, 1.05, this.QPmax, 1.0, 0.01, this.roundPoints, false);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(-this.QPmax, 1.1, -this.QPmax, 1.0, 0.01, this.roundPoints, false);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(-this.QPmax, 1.0, -this.QPmax, 0.95, 0.01, this.roundPoints, false);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(-this.QPmax, 0.95, 0, 0.9, 0.001, this.roundPoints, false);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawPolyQPd(0.9, 1.0, 0.0002, "right");
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawPolyQPd(0.9, 1.0, 0.0002, "left");
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(0, 0.9, 0, 0.85, 0.01, this.roundPoints, false);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(0, 0.85, this.QPmax, 0.85, this.QPmax / 30, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(this.QPmax, 0.85, this.QPmax, 1.0, this.QPmax / 30, this.roundPoints, false);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);
      } else if (this.chart === "C") {
        xy = DrawLine(this.v5 - 5, 100, this.v5, 100, (this.v5 - (this.v5 - 5)) * this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(this.v5, 100, this.v6, this.activeMinimumPowerPU, (this.v6 - this.v5) * this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(this.v6, this.activeMinimumPowerPU, this.v7, this.activeMinimumPowerPU, (this.v7 - this.v6) * this.step * 2, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        this.staticArrayChartSeries2.push([this.v5, 100]);
        this.staticArrayChartSeries2.push([this.v6, this.activeMinimumPowerPU]);
        this.staticArrayChartSeries2.push([this.v7, this.activeMinimumPowerPU]);
      } else if (this.chart === "D") {
        xy = DrawLine(this.v1 - 20, this.y1, this.v1, this.y1, (this.v1 - (this.v1 - 20)) * this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(this.v1, this.y1, this.v2, this.y2, (this.v2 - this.v1) * this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(this.v2, this.y2, this.v3, this.y3, (this.v3 - this.v2) * this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(this.v3, this.y3, this.v4, this.y4, (this.v4 - this.v3) * this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(this.v4, this.y4, this.v4 + 20, this.y4, (this.v4 + 20 - this.v4) * this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        this.staticArrayChartSeries2.push([this.v1, this.y1]);
        this.staticArrayChartSeries2.push([this.v2, this.y2]);
        this.staticArrayChartSeries2.push([this.v3, this.y3]);
        this.staticArrayChartSeries2.push([this.v4, this.y4]);
      } else if (this.chart === "E") {
        xy = DrawLine(0, 1, this.Smax * 0.25, 1, this.stepWatts, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(this.Smax * 0.25, 1, (this.PFCurveForCosPhi_PowerReponse_X1 / 100) * this.Smax, 1, this.stepWatts, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine((this.PFCurveForCosPhi_PowerReponse_X1 / 100) * this.Smax, 1, (this.PFCurveForCosPhi_PowerReponse_X2 / 100) * this.Smax, this.powerFactor, this.stepWatts, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);
      } else if (this.chart === "F") {
        let qfULockIn = 0;
        let qfULockOut = 0;

        if (this.qfULockIn > 1.0) {
          qfULockIn = this.qfULockIn / 100;
        } else {
          qfULockIn = this.qfULockIn;
        }

        if (this.qfULockOut > 1.0) {
          qfULockOut = this.qfULockOut / 100;
        } else {
          qfULockOut = this.qfULockOut;
        }

        xy = DrawLine(0, 0, qfULockIn * this.Smax, 0, this.stepWatts, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(qfULockIn * this.Smax, 0, qfULockIn * this.Smax, 1, this.step, this.roundPoints, false);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(qfULockOut * this.Smax, 1, this.Smax, 1, this.stepWatts, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        xy = DrawLine(qfULockOut * this.Smax, 1, qfULockOut * this.Smax, 0, this.step, this.roundPoints, false);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);

        this.staticArrayChartSeries2.push([qfULockIn * this.Smax, 0]);
        this.staticArrayChartSeries2.push([qfULockOut * this.Smax, 1]);
      } else if (this.chart === "G") {
        let PfFrequencyUpper_Y2_100Pn = 0;
        let PfFrequencyUpper_Y2_75Pn = 0;
        let PfFrequencyUpper_Y2_50Pn = 0;
        let PfFrequencyUpper_Y2_25Pn = 0;
        let PfFrequencyUpper_Y2_0Pn = 0;
        let PfFrequencyUpper_Y2_Charge100Pn = 0;
        let PfFrequencyUpper_Y2_Charge75Pn = 0;
        let PfFrequencyUpper_Y2_Charge50Pn = 0;
        let PfFrequencyUpper_Y2_Charge25Pn = 0;

        if (this.EN_P_f_f_Gradient == true) {
          PfFrequencyUpper_Y2_100Pn = this.Smax * 1.0 - (100 * ((this.frequencyMax - this.P_HF_ThresholdFreq) / 50) * this.Smax) / this.P_HF_Gradient;
          PfFrequencyUpper_Y2_75Pn = this.Smax * 0.75 - (100 * ((this.frequencyMax - this.P_HF_ThresholdFreq) / 50) * this.Smax) / this.P_HF_Gradient;
          PfFrequencyUpper_Y2_50Pn = this.Smax * 0.5 - (100 * ((this.frequencyMax - this.P_HF_ThresholdFreq) / 50) * this.Smax) / this.P_HF_Gradient;
          PfFrequencyUpper_Y2_25Pn = this.Smax * 0.25 - (100 * ((this.frequencyMax - this.P_HF_ThresholdFreq) / 50) * this.Smax) / this.P_HF_Gradient;
          PfFrequencyUpper_Y2_0Pn = this.Smax * 0 - (100 * ((this.frequencyMax - this.P_HF_ThresholdFreq) / 50) * this.Smax) / this.P_HF_Gradient;
          PfFrequencyUpper_Y2_Charge100Pn = -this.Smax * 1.0 - (100 * ((this.frequencyMax - this.P_HF_ThresholdFreq) / 50) * this.Smax) / this.P_HF_Gradient;
          PfFrequencyUpper_Y2_Charge75Pn = -this.Smax * 0.75 - (100 * ((this.frequencyMax - this.P_HF_ThresholdFreq) / 50) * this.Smax) / this.P_HF_Gradient;
          PfFrequencyUpper_Y2_Charge50Pn = -this.Smax * 0.5 - (100 * ((this.frequencyMax - this.P_HF_ThresholdFreq) / 50) * this.Smax) / this.P_HF_Gradient;
          PfFrequencyUpper_Y2_Charge25Pn = -this.Smax * 0.25 - (100 * ((this.frequencyMax - this.P_HF_ThresholdFreq) / 50) * this.Smax) / this.P_HF_Gradient;
        } else {
          PfFrequencyUpper_Y2_100Pn = this.Smax * 1.0 * (1 - (this.frequencyMax - this.P_HF_ThresholdFreq) / (this.P_HF_StopFreq - this.P_HF_ThresholdFreq));
          PfFrequencyUpper_Y2_75Pn = this.Smax * 0.75 * (1 - (this.frequencyMax - this.P_HF_ThresholdFreq) / (this.P_HF_StopFreq - this.P_HF_ThresholdFreq));
          PfFrequencyUpper_Y2_50Pn = this.Smax * 0.5 * (1 - (this.frequencyMax - this.P_HF_ThresholdFreq) / (this.P_HF_StopFreq - this.P_HF_ThresholdFreq));
          PfFrequencyUpper_Y2_25Pn = this.Smax * 0.25 * (1 - (this.frequencyMax - this.P_HF_ThresholdFreq) / (this.P_HF_StopFreq - this.P_HF_ThresholdFreq));
          PfFrequencyUpper_Y2_0Pn = this.Smax * 0 * (1 - (this.frequencyMax - this.P_HF_ThresholdFreq) / (this.P_HF_StopFreq - this.P_HF_ThresholdFreq));
          PfFrequencyUpper_Y2_Charge100Pn = -this.Smax * 1.0 * (1 - (this.frequencyMax - this.P_HF_ThresholdFreq) / (this.P_HF_StopFreq - this.P_HF_ThresholdFreq));
          PfFrequencyUpper_Y2_Charge75Pn = -this.Smax * 0.75 * (1 - (this.frequencyMax - this.P_HF_ThresholdFreq) / (this.P_HF_StopFreq - this.P_HF_ThresholdFreq));
          PfFrequencyUpper_Y2_Charge50Pn = -this.Smax * 0.5 * (1 - (this.frequencyMax - this.P_HF_ThresholdFreq) / (this.P_HF_StopFreq - this.P_HF_ThresholdFreq));
          PfFrequencyUpper_Y2_Charge25Pn = -this.Smax * 0.25 * (1 - (this.frequencyMax - this.P_HF_ThresholdFreq) / (this.P_HF_StopFreq - this.P_HF_ThresholdFreq));
        }

        // Line between threshold frequency lower and upper
        xy = DrawLine(this.P_LF_ThresholdFreq, this.Smax * 1.0, this.P_HF_ThresholdFreq, this.Smax * 1.0, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, this.Smax * 0.75, this.P_HF_ThresholdFreq, this.Smax * 0.75, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries2, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, this.Smax * 0.5, this.P_HF_ThresholdFreq, this.Smax * 0.5, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries3, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, this.Smax * 0.25, this.P_HF_ThresholdFreq, this.Smax * 0.25, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries4, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, this.Smax * 0, this.P_HF_ThresholdFreq, 0, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries5, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, -this.Smax * 0.25, this.P_HF_ThresholdFreq, -this.Smax * 0.25, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries6, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, -this.Smax * 0.5, this.P_HF_ThresholdFreq, -this.Smax * 0.5, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries7, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, -this.Smax * 0.75, this.P_HF_ThresholdFreq, -this.Smax * 0.75, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries8, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, -this.Smax * 1.0, this.P_HF_ThresholdFreq, -this.Smax * 1.0, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries9, xy);

        // Drop calculation
        xy = DrawLine(this.P_HF_ThresholdFreq, this.Smax * 1.0, this.frequencyMax, PfFrequencyUpper_Y2_100Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);
        xy = DrawLine(this.P_HF_ThresholdFreq, this.Smax * 0.75, this.frequencyMax, PfFrequencyUpper_Y2_75Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries2, xy);
        xy = DrawLine(this.P_HF_ThresholdFreq, this.Smax * 0.5, this.frequencyMax, PfFrequencyUpper_Y2_50Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries3, xy);
        xy = DrawLine(this.P_HF_ThresholdFreq, this.Smax * 0.25, this.frequencyMax, PfFrequencyUpper_Y2_25Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries4, xy);
        xy = DrawLine(this.P_HF_ThresholdFreq, this.Smax * 0, this.frequencyMax, PfFrequencyUpper_Y2_0Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries5, xy);
        xy = DrawLine(this.P_HF_ThresholdFreq, -this.Smax * 0.25, this.frequencyMax, PfFrequencyUpper_Y2_Charge25Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries6, xy);
        xy = DrawLine(this.P_HF_ThresholdFreq, -this.Smax * 0.5, this.frequencyMax, PfFrequencyUpper_Y2_Charge50Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries7, xy);
        xy = DrawLine(this.P_HF_ThresholdFreq, -this.Smax * 0.75, this.frequencyMax, PfFrequencyUpper_Y2_Charge75Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries8, xy);
        xy = DrawLine(this.P_HF_ThresholdFreq, -this.Smax * 1.0, this.frequencyMax, PfFrequencyUpper_Y2_Charge100Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries9, xy);

        //
        xy = DrawLine(this.P_LF_ThresholdFreq, 0, this.frequencyMax, 0, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries10, xy);

        xy = DrawLine(this.P_HF_ThresholdFreq, -this.Smax, this.P_HF_ThresholdFreq, this.Smax, this.stepWatts * 3, this.roundPoints, false);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries10, xy);

        this.staticArrayChartSeries1 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries1, -this.Smax, this.Smax);
        this.staticArrayChartSeries2 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries2, -this.Smax, this.Smax);
        this.staticArrayChartSeries3 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries3, -this.Smax, this.Smax);
        this.staticArrayChartSeries4 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries4, -this.Smax, this.Smax);
        this.staticArrayChartSeries5 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries5, -this.Smax, this.Smax);
        this.staticArrayChartSeries6 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries6, -this.Smax, this.Smax);
        this.staticArrayChartSeries7 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries7, -this.Smax, this.Smax);
        this.staticArrayChartSeries8 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries8, -this.Smax, this.Smax);
        this.staticArrayChartSeries9 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries9, -this.Smax, this.Smax);
        this.staticArrayChartSeries10 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries10, -this.Smax, this.Smax);
      } else if (this.chart === "H") {
        let PfFrequencyLower_Y2_100Pn = 0;
        let PfFrequencyLower_Y2_75Pn = 0;
        let PfFrequencyLower_Y2_50Pn = 0;
        let PfFrequencyLower_Y2_25Pn = 0;
        let PfFrequencyLower_Y2_0Pn = 0;
        let PfFrequencyLower_Y2_Charge100Pn = 0;
        let PfFrequencyLower_Y2_Charge75Pn = 0;
        let PfFrequencyLower_Y2_Charge50Pn = 0;
        let PfFrequencyLower_Y2_Charge25Pn = 0;

        if (this.EN_P_f_f_Gradient == true) {
          PfFrequencyLower_Y2_100Pn = this.Smax * 1.0 + (100 * ((this.P_LF_ThresholdFreq - this.frequencyMin) / 50) * this.Smax) / this.P_LF_Gradient;
          PfFrequencyLower_Y2_75Pn = this.Smax * 0.75 + (100 * ((this.P_LF_ThresholdFreq - this.frequencyMin) / 50) * this.Smax) / this.P_LF_Gradient;
          PfFrequencyLower_Y2_50Pn = this.Smax * 0.5 + (100 * ((this.P_LF_ThresholdFreq - this.frequencyMin) / 50) * this.Smax) / this.P_LF_Gradient;
          PfFrequencyLower_Y2_25Pn = this.Smax * 0.25 + (100 * ((this.P_LF_ThresholdFreq - this.frequencyMin) / 50) * this.Smax) / this.P_LF_Gradient;
          PfFrequencyLower_Y2_0Pn = this.Smax * 0 + (100 * ((this.P_LF_ThresholdFreq - this.frequencyMin) / 50) * this.Smax) / this.P_LF_Gradient;
          PfFrequencyLower_Y2_Charge100Pn = -this.Smax * 1.0 + (100 * ((this.P_LF_ThresholdFreq - this.frequencyMin) / 50) * this.Smax) / this.P_LF_Gradient;
          PfFrequencyLower_Y2_Charge75Pn = -this.Smax * 0.75 + (100 * ((this.P_LF_ThresholdFreq - this.frequencyMin) / 50) * this.Smax) / this.P_LF_Gradient;
          PfFrequencyLower_Y2_Charge50Pn = -this.Smax * 0.5 + (100 * ((this.P_LF_ThresholdFreq - this.frequencyMin) / 50) * this.Smax) / this.P_LF_Gradient;
          PfFrequencyLower_Y2_Charge25Pn = -this.Smax * 0.25 + (100 * ((this.P_LF_ThresholdFreq - this.frequencyMin) / 50) * this.Smax) / this.P_LF_Gradient;
        } else {
          PfFrequencyLower_Y2_100Pn = this.Smax * 1.0 * (1 - (this.P_LF_ThresholdFreq - this.frequencyMin) / (this.P_LF_ThresholdFreq - this.P_HF_StopFreq));
          PfFrequencyLower_Y2_75Pn = this.Smax * 0.75 * (1 - (this.P_LF_ThresholdFreq - this.frequencyMin) / (this.P_LF_ThresholdFreq - this.P_HF_StopFreq));
          PfFrequencyLower_Y2_50Pn = this.Smax * 0.5 * (1 - (this.P_LF_ThresholdFreq - this.frequencyMin) / (this.P_LF_ThresholdFreq - this.P_HF_StopFreq));
          PfFrequencyLower_Y2_25Pn = this.Smax * 0.25 * (1 - (this.P_LF_ThresholdFreq - this.frequencyMin) / (this.P_LF_ThresholdFreq - this.P_HF_StopFreq));
          PfFrequencyLower_Y2_0Pn = this.Smax * 0 * (1 - (this.P_LF_ThresholdFreq - this.frequencyMin) / (this.P_LF_ThresholdFreq - this.P_HF_StopFreq));
          PfFrequencyLower_Y2_Charge100Pn = -this.Smax * 1.0 * (1 - (this.P_LF_ThresholdFreq - this.frequencyMin) / (this.P_LF_ThresholdFreq - this.P_HF_StopFreq));
          PfFrequencyLower_Y2_Charge75Pn = -this.Smax * 0.75 * (1 - (this.P_LF_ThresholdFreq - this.frequencyMin) / (this.P_LF_ThresholdFreq - this.P_HF_StopFreq));
          PfFrequencyLower_Y2_Charge50Pn = -this.Smax * 0.5 * (1 - (this.P_LF_ThresholdFreq - this.frequencyMin) / (this.P_LF_ThresholdFreq - this.P_HF_StopFreq));
          PfFrequencyLower_Y2_Charge25Pn = -this.Smax * 0.25 * (1 - (this.P_LF_ThresholdFreq - this.frequencyMin) / (this.P_LF_ThresholdFreq - this.P_HF_StopFreq));
        }

        // Line between threshold frequency lower and upper
        xy = DrawLine(this.P_LF_ThresholdFreq, this.Smax * 1.0, this.P_HF_ThresholdFreq, this.Smax * 1.0, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, this.Smax * 0.75, this.P_HF_ThresholdFreq, this.Smax * 0.75, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries2, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, this.Smax * 0.5, this.P_HF_ThresholdFreq, this.Smax * 0.5, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries3, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, this.Smax * 0.25, this.P_HF_ThresholdFreq, this.Smax * 0.25, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries4, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, this.Smax * 0, this.P_HF_ThresholdFreq, 0, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries5, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, -this.Smax * 0.25, this.P_HF_ThresholdFreq, -this.Smax * 0.25, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries6, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, -this.Smax * 0.5, this.P_HF_ThresholdFreq, -this.Smax * 0.5, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries7, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, -this.Smax * 0.75, this.P_HF_ThresholdFreq, -this.Smax * 0.75, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries8, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, -this.Smax * 1.0, this.P_HF_ThresholdFreq, -this.Smax * 1.0, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries9, xy);

        // Drop calculation
        xy = DrawLine(this.P_LF_ThresholdFreq, this.Smax * 1.0, this.frequencyMin, PfFrequencyLower_Y2_100Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries1, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, this.Smax * 0.75, this.frequencyMin, PfFrequencyLower_Y2_75Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries2, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, this.Smax * 0.5, this.frequencyMin, PfFrequencyLower_Y2_50Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries3, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, this.Smax * 0.25, this.frequencyMin, PfFrequencyLower_Y2_25Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries4, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, this.Smax * 0, this.frequencyMin, PfFrequencyLower_Y2_0Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries5, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, -this.Smax * 0.25, this.frequencyMin, PfFrequencyLower_Y2_Charge25Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries6, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, -this.Smax * 0.5, this.frequencyMin, PfFrequencyLower_Y2_Charge50Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries7, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, -this.Smax * 0.75, this.frequencyMin, PfFrequencyLower_Y2_Charge75Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries8, xy);
        xy = DrawLine(this.P_LF_ThresholdFreq, -this.Smax * 1.0, this.frequencyMin, PfFrequencyLower_Y2_Charge100Pn, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries9, xy);

        xy = DrawLine(this.P_HF_ThresholdFreq, 0, this.frequencyMin, 0, this.step, this.roundPoints, true);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries10, xy);

        xy = DrawLine(this.P_LF_ThresholdFreq, -this.Smax, this.P_LF_ThresholdFreq, this.Smax, this.stepWatts * 3, this.roundPoints, false);
        this.pushPointsIntoExistingArray(this.staticArrayChartSeries10, xy);

        this.staticArrayChartSeries1 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries1, -this.Smax, this.Smax);
        this.staticArrayChartSeries2 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries2, -this.Smax, this.Smax);
        this.staticArrayChartSeries3 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries3, -this.Smax, this.Smax);
        this.staticArrayChartSeries4 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries4, -this.Smax, this.Smax);
        this.staticArrayChartSeries5 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries5, -this.Smax, this.Smax);
        this.staticArrayChartSeries6 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries6, -this.Smax, this.Smax);
        this.staticArrayChartSeries7 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries7, -this.Smax, this.Smax);
        this.staticArrayChartSeries8 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries8, -this.Smax, this.Smax);
        this.staticArrayChartSeries9 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries9, -this.Smax, this.Smax);
        this.staticArrayChartSeries10 = this.extremeLimitationXYDataSeries(this.staticArrayChartSeries10, -this.Smax, this.Smax);
      }
    },
    changeXYAxis(xAxisName, yAxisName, xAxisPlaces, yAxisPlaces, xAxisMin, xAxisMax, yAxisMin, yAxisMax) {
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          xaxis: {
            tickAmount: 16,
            min: xAxisMin,
            max: xAxisMax,
            labels: {
              style: {
                colors: this.dark ? "#E0E0E0" : "#212121",
              },
              formatter: function (val) {
                return parseFloat(val).toFixed(xAxisPlaces);
              },
            },

            title: {
              text: xAxisName,
              offsetX: 0,
              offsetY: 0,
              style: {
                color: this.dark ? "#E0E0E0" : "#212121",
                fontSize: "12px",
                fontFamily: "Helvetica, Arial, sans-serif",
                fontWeight: 600,
                cssClass: "apexcharts-xaxis-title",
              },
            },
          },
          yaxis: {
            tickAmount: 8,
            min: yAxisMin,
            max: yAxisMax,
            labels: {
              style: {
                colors: this.dark ? "#E0E0E0" : "#212121",
              },
              formatter: function (val) {
                return parseFloat(val).toFixed(yAxisPlaces); // + "VAr";
              },
            },
            title: {
              text: yAxisName,
              offsetX: 0,
              offsetY: 0,
              style: {
                color: this.dark ? "#E0E0E0" : "#212121",
                fontSize: "12px",
                fontFamily: "Helvetica, Arial, sans-serif",
                fontWeight: 600,
                cssClass: "apexcharts-xaxis-title",
              },
            },
          },
        },
      };
    },
    changeMarkersSize(sizeArray) {
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          markers: {
            size: sizeArray,
            colors: undefined,
            strokeColors: this.dark ? "#212121" : "#fff",
            strokeWidth: 2,
            strokeOpacity: 0.9,
            strokeDashArray: 0,
            fillOpacity: 1,
            discrete: [],
            shape: "circle",
            radius: 2,
            offsetX: 0,
            offsetY: 0,
            onClick: undefined,
            onDblClick: undefined,
            showNullDataPoints: true,
            hover: {
              size: undefined,
              sizeOffset: 3,
            },
          },
        },
      };
    },
  },
  watch: {
    P1: function () {
      this.updateChart();
    },
    Q1: function () {
      this.updateChart();
    },
    S1: function () {
      this.updateChart();
    },
    U1: function () {
      this.updateChart();
    },
    dark: function () {
      this.setTheme();
    },
  },
};
</script>

<style scoped></style>
